import { cn } from 'support/helpers/cn/cn';
import { ButtonType } from 'components/Form/Button/Button';

const edgePadding: Record<NonNullable<ButtonType['size']>, string> = {
  'extra-small': '[&>*:first-child]:pl-3.5 [&>*:last-child]:pr-3.5',
  small: '[&>*:first-child]:pl-4 [&>*:last-child]:pr-4',
  base: '[&>*:first-child]:pl-5 [&>*:last-child]:pr-5',
  large: '[&>*:first-child]:pl-5 [&>*:last-child]:pr-5',
  'extra-large': '[&>*:first-child]:pl-7 [&>*:last-child]:pr-7',
};

type ButtonGroupProps = {
  children: React.ReactNode;
  size?: ButtonType['size'];
  className?: string;
};

export const ButtonGroup = ({ children, size = 'extra-small', className }: ButtonGroupProps) => (
  <div
    className={cn(
      'inline-flex items-center overflow-hidden rounded-full border border-gray-200 bg-white',
      '[&>button]:rounded-none!',
      edgePadding[size],
      className ?? '',
    )}
  >
    {children}
  </div>
);
